import { render } from "./GenericModal.vue?vue&type=template&id=d00f1082&scoped=true&ts=true"
import script from "./GenericModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericModal.vue?vue&type=script&setup=true&lang=ts"

import "./GenericModal.vue?vue&type=style&index=0&id=d00f1082&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00f1082"],['__file',"src/components/modals/newModal/GenericModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d00f1082"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d00f1082', __exports__)) {
    api.reload('d00f1082', __exports__)
  }
  
  module.hot.accept("./GenericModal.vue?vue&type=template&id=d00f1082&scoped=true&ts=true", () => {
    api.rerender('d00f1082', render)
  })

}


export default __exports__